export default {
    patchNote: "Примечания к патчу",
    currentPatchNote: "Текущий патч ноут",
    newPatchNote: "Патч ноут доступной версии",
}